import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';

import { PetlService } from '../../services/petl.service';
import { BaseComponent } from '../base.component';

export class PetlBaseComponent extends BaseComponent {

    showHelp?: boolean;
    showIssues?: boolean;

    constructor(_vcr: ViewContainerRef, protected readonly petlService: PetlService, protected readonly cdr: ChangeDetectorRef) {
        super(_vcr);
    }

    get currentProject() {
        return this.petlService.project;
    }

    get currentView() {
        return this.petlService.currentView;
    }

    get loading() {
        return this.petlService.loading;
    }
    set loading(value: boolean) {
        this.petlService.loading = value;
    }

    get user() {
        return this.petlService.user;
    }

    get service() {
        return this.petlService;
    }

    detectChanges() {
        this.cdr.detectChanges();
    }

    changeView(viewName: string) {
        this.petlService.changeView(viewName);
    }

    toggleHelp() {
        this.showHelp = !this.showHelp;
    }

    toggleView(viewName: string) {
        this.petlService.toggleView(viewName);
    }

}
